import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../shared/Icon';
import CompactSearchBar from './CompactSearchBar';

/**
 * Search on the refreshed Home: one quiet pill under the rail ("What do you
 * feel like doing?") that opens the full search bar in place — where, when,
 * who's going, the mood templates — the hero's search button opens it too.
 * The page no longer starts with a 170–320px search form; the hero and
 * the weekend are what you see first.
 */
const HomeSearch = forwardRef(function HomeSearch({ search, open, onOpenChange }, ref) {
  const { t } = useTranslation('home');
  return (
    <div ref={ref} className="scroll-mt-20">
      {open ? (
        <div className="bg-surface rounded-card border border-border">
          <CompactSearchBar search={search} />
          <div className="flex justify-end px-4 pb-2">
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="text-sm font-semibold text-primary min-h-[44px] px-2 rounded-lg hover:bg-primary-lighter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light"
            >
              {t('search.hide')}
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => onOpenChange(true)}
          className="w-full h-12 flex items-center gap-3 px-4 bg-surface rounded-xl border border-border text-content-secondary text-left can-hover:hover:border-content-muted transition-colors duration-fast focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light"
        >
          <Icon name="search" className="w-5 h-5 flex-shrink-0" />
          <span className="flex-1 truncate">{t('search.prompt')}</span>
          <span className="hidden sm:inline text-xs font-semibold text-content-muted">{t('search.hint')}</span>
        </button>
      )}
    </div>
  );
});

export default HomeSearch;
